import { ListItem as MuiListItem, ListItemProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { ListItemProps };

export const ListItem: React.ComponentType<ListItemProps> = styled(MuiListItem)<ListItemProps>(
  () => ({}),
);
